import { stopRecognition } from '../speech';

const modal = document.querySelector<HTMLDivElement>('#modal')!;
const body = document.querySelector<HTMLDivElement>('#body')!;
const title = document.querySelector<HTMLHeadingElement>('#title')!;

export function escapeHtml(value: unknown): string {
  return String(value).replace(/[&<>'"]/g, (c) => (
    { '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c] ?? c
  ));
}

export function show(heading: string, html: string): void {
  stopRecognition();
  title.textContent = heading;
  body.innerHTML = html;
  modal.classList.remove('hidden');
}

export function hideModal(): void {
  stopRecognition();
  modal.classList.add('hidden');
}

export function modalBody(): HTMLDivElement {
  return body;
}

export function $<T extends HTMLElement>(selector: string): T | null {
  return document.querySelector<T>(selector);
}

export function need<T extends HTMLElement>(selector: string): T {
  const el = document.querySelector<T>(selector);
  if (!el) throw new Error(`Falta el elemento ${selector}`);
  return el;
}

export function toast(text: string, ms = 2200): void {
  document.querySelector('.toast')?.remove();
  const el = document.createElement('div');
  el.className = 'toast';
  el.textContent = text;
  document.body.append(el);
  setTimeout(() => el.remove(), ms);
}

export function localDateISO(d = new Date()): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function initModal(): void {
  need('#close').onclick = hideModal;
  modal.onclick = (e) => { if (e.target === modal) hideModal(); };
}
